const steps = [
  {
    number: '01',
    title: 'Consultation & Site Evaluation',
    desc: 'We meet at your property for a free consultation, assess site conditions, and discuss your vision, goals, and budget in detail.',
    icon: 'ri-user-voice-line',
    color: 'bg-parkside-amber',
  },
  {
    number: '02',
    title: 'Custom Design & Planning',
    desc: 'Our team creates a tailored design plan that matches your style and maximizes the functionality of your outdoor space.',
    icon: 'ri-pencil-ruler-2-line',
    color: 'bg-parkside-green',
  },
  {
    number: '03',
    title: 'Material Selection',
    desc: 'Choose from premium brands like Belgard and Tremron across a wide range of styles, colors, and textures.',
    icon: 'ri-stack-line',
    color: 'bg-parkside-amber',
  },
  {
    number: '04',
    title: 'Professional Installation',
    desc: 'Our ICPI-certified crew handles all base preparation, drainage, and precision installation to industry-leading standards.',
    icon: 'ri-tools-fill',
    color: 'bg-parkside-green',
  },
  {
    number: '05',
    title: 'Final Walkthrough',
    desc: 'We conduct a thorough walkthrough with you to ensure every detail meets our high standards and your complete satisfaction.',
    icon: 'ri-checkbox-circle-fill',
    color: 'bg-parkside-amber',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-parkside-green/10 text-parkside-green text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-3">
            How It Works
          </span>
          <h2 className="font-display text-4xl md:text-5xl text-parkside-dark mb-4 tracking-display leading-tight">
            Our Proven Installation Process
          </h2>
          <p className="text-parkside-muted max-w-xl mx-auto text-base leading-relaxed">
            From the first call to the final walkthrough — a smooth, transparent process built around your project.
          </p>
        </div>

        {/* Desktop horizontal timeline */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Connector line */}
            <div className="absolute top-10 left-[calc(10%+28px)] right-[calc(10%+28px)] h-px bg-gradient-to-r from-parkside-amber/30 via-parkside-green to-parkside-amber/30" />

            <div className="grid grid-cols-5 gap-6">
              {steps.map((step) => (
                <div key={step.number} className="flex flex-col items-center text-center">
                  <div className="relative mb-6">
                    <div className={`w-20 h-20 rounded-full ${step.color} flex items-center justify-center relative z-10`}>
                      <i className={`${step.icon} text-white text-2xl`} />
                    </div>
                    <div className="absolute -top-2 -right-1 w-7 h-7 bg-white border-2 border-parkside-dark rounded-full flex items-center justify-center z-20">
                      <span className="text-parkside-dark font-bold text-[10px]">{step.number}</span>
                    </div>
                  </div>
                  <h3 className="font-bold text-parkside-dark text-sm mb-2 px-2 leading-snug">{step.title}</h3>
                  <p className="text-parkside-stone text-xs leading-relaxed px-1">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile vertical timeline */}
        <div className="lg:hidden space-y-0">
          {steps.map((step, idx) => (
            <div key={step.number} className="flex gap-5 relative">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-12 h-12 rounded-full ${step.color} flex items-center justify-center z-10`}>
                  <i className={`${step.icon} text-white text-lg`} />
                </div>
                {idx < steps.length - 1 && (
                  <div className="w-px flex-1 bg-stone-200 my-2" />
                )}
              </div>
              <div className="pb-8 pt-1">
                <span className="text-xs font-bold text-parkside-amber tracking-widest">{step.number}</span>
                <h3 className="font-bold text-parkside-dark text-base mt-0.5 mb-1.5">{step.title}</h3>
                <p className="text-parkside-muted text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
